import { render, staticRenderFns } from "./tip-tap-display.html?vue&type=template&id=344be8fe&scoped=true&"
import script from "./tip-tap-display.js?vue&type=script&lang=js&"
export * from "./tip-tap-display.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344be8fe",
  null
  
)

export default component.exports